export const clickCategories = {
    HEADER: 'Header',
    POWER_UPGRADE: 'Power Upgrade',
    ACTIVITY_STATS: 'Activity Stats',
    PLAYER_PROFILE: 'Player Profile',
};

export const clickLocations = {
    HEADER_CTA: 'Header CTA',
    PROFILE_STATS_TAB: 'Player Profile Stats Tab',
    PROFILE_ACTIVITY_STATS: 'Player Profile Activity Stats',
};

export const profileAnalyticsEvents = {
    TAB_VIEWED: 'Profile Tab Viewed',
    STATS_VIEW_CHANGED: 'Activity Stats View Changed',
    GAME_TYPE_CHANGED: 'Game Type Changed',
    VERIFIED_TOGGLE_CHANGED: 'Verified Toggle Changed',
    TIME_RANGE_SELECTED: 'Time Range Selected',
    EVENT_CTA_CLICKED: 'Event CTA Clicked',
};

export const activityStatsAnalyticsEvents = {
    GAME_TYPE_SELECTED: 'activity_stats_game_type_selected',
    TIMEFRAME_SELECTED: 'activity_stats_timeframe_selected',
    VERIFIED_ONLY_TOGGLED: 'activity_stats_verified_only_toggled',
    FIND_EVENTS_CTA_TAPPED: 'activity_stats_find_events_cta_tapped',
};

export const performanceStatsAnalyticsEvents = {
    VIEW_ALL_RESULTS_TAPPED: 'performance_stats_view_all_results_tapped',
    GET_POWER_CTA_TAPPED: 'performance_stats_get_power_cta_tapped',
};

export const statsAnalyticsEvents = {
    SUBTAB_CLICKED: 'stats_subtab_clicked',
    PERFORMANCE_STATS_ENGAGEMENT: 'performance_stats_engagement',
};

export const statsSubtabNames = {
    RATING: 'rating_stats',
    ACTIVITY: 'activity_stats',
    PERFORMANCE: 'performance_stats',
};

export const performanceStatsEngagementTypes = {
    CLICK_RESULT: 'click_result',
    GO_TO_OTHER_PROFILE: 'go_to_other_profile',
    CLICK_MORE_RESULTS: 'click_more_results',
};

export const getAnalyticsCommonTraits = (auth) => ({
    subscriptionTier: auth?.user?.isPowered ? 'power' : 'free',
    platform: typeof window !== 'undefined' && window.innerWidth <= 768 ? 'mobile_web' : 'desktop_web',
});

export const getActivityStatsTraits = (auth, playerId, isOwnProfile) => ({
    memberId: auth?.user?.id,
    subscriptionType: auth?.user?.isPowered ? 'Power' : 'free',
    platform: typeof window !== 'undefined' && window.innerWidth <= 768 ? 'mobile_web' : 'desktop_web',
    player_id: playerId,
    is_own_profile: !!isOwnProfile,
});

// player_id here is the profile navigated *to*, not the profile being viewed —
// DS-102 defines it that way, so the viewed profile moves to profile_player_id.
export const getPerformanceStatsEngagementTraits = (auth, profilePlayerId, engagementType, opponentPlayerId = null) => ({
    memberId: auth?.user?.id,
    subscriptionType: auth?.user?.isPowered ? 'Power' : 'free',
    platform: typeof window !== 'undefined' && window.innerWidth <= 768 ? 'mobile_web' : 'desktop_web',
    profile_player_id: profilePlayerId,
    engagement_type: engagementType,
    player_id: opponentPlayerId ?? null,
});
